module.exports = __webpack_public_path__ + "img/Menu-09.4966d624.png";